import DataHandling from './DataHandling';

export default DataHandling;
